import styled, { css } from "styled-components"

import CtaLink from "~/components/atoms/CtaLink"
import TransitionLink from "~/components/atoms/TransitionLink"
import Typography from "~/components/atoms/Typography"
import { ContainerLarge } from "~/components/layouts/Container"
import { Color, IsMobile, IsPC, LineHeight, RadiusSize, Shadow, SpacingSize, TextSize } from "~/consts/style-mixins"

export const PageContainer = styled.div`
  overflow: hidden;
`

export const Container = styled(ContainerLarge)`
  position: relative;
  &.odd-gray {
    background: ${Color.BackgroundGray};
  }
  &.odd-blue {
    background: ${Color.BackgroundSecondary};
  }
  .decoration {
    position: absolute;
    z-index: 1;
    &.d1 {
      top: 0;
      left: 0;
    }
    &.d2 {
      bottom: 24px;
      right: 0;
      ${IsMobile(`
        display: none;
      `)};
    }
    &.d3 {
      top: -18px;
      left: 0;
      ${IsMobile(`
        width: 32%;
      `)};
    }
    &.d4 {
      bottom: -64px;
      right: 0;
      ${IsMobile(css`
        width: 32%;
        bottom: -80px;
        right: -35px;
      `)};
    }
    &.d6 {
      top: -20px;
      right: 0;
      ${IsMobile(`
        width: 32%;
        right: -30px;
      `)};
    }
    &.d7 {
      width: 88px;
      top: -22px;
      left: 0;
      ${IsMobile(`
        display: none;
      `)};
    }
    &.d9 {
      top: -12px;
      left: 0;
      ${IsMobile(`
        width: 32%;
        top: -24px;
        left: -10px;
      `)};
    }
  }
`
export const MainVisual = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 360px;
  background-image: url("/next/static/images/infra-event/mv-pc.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  ${IsMobile(css`
    height: 250px;
    background-image: url("/next/static/images/infra-event/mv-sp.png");
  `)}
`
export const MainVisualCard = styled.div`
  background: ${Color.White};
  padding: ${SpacingSize.M}px ${SpacingSize["2XL"]}px;
  text-align: center;
  border-radius: ${RadiusSize.Medium}px;
  ${Shadow.Deep};
`
export const MainVisualSupplement = styled(Typography)`
  color: ${Color.Gray};
  line-height: ${LineHeight.S}%;
  ${IsPC(css`
    font-size: 16px;
  `)}
`
export const MainVisualTitle = styled(Typography)`
  color: ${Color.Primary};
  margin-top: ${SpacingSize["3XS"]}px;
  ${IsPC(css`
    font-size: 28px;
  `)}
`
export const Heading = styled(Typography)`
  text-align: center;
`
export const Section = styled.div`
  padding: ${SpacingSize["4XL"]}px 0;
  ${IsMobile(css`
    padding: 40px 0;
  `)}
`
export const EventList = styled.ul`
  margin-top: 12px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  ${IsMobile(css`
    flex-direction: column;
    margin-top: 40px;
  `)}
`
export const EventItem = styled.li`
  width: 50%;
  max-width: 400px;
  margin-top: ${SpacingSize.XL}px;
  padding: 0 ${SpacingSize.XS}px;
  ${IsMobile(css`
    width: 100%;
    &:first-child {
      margin-top: 0;
    }
  `)}
  .thumbnail-container {
    height: 200px;
    padding: 18px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-weight: bold;
    color: ${Color.White};
    text-align: right;
    border-radius: 16px 16px 0 0;
    &.draft {
      background-image: url("/next/static/images/infra-event/draft-thumbnail.png");
      background-size: cover;
      .title-top-sub {
        margin-bottom: 4px;
      }
      .title-top-main {
        font-size: 42px;
      }
    }
    &.jobs {
      background-image: url("/next/static/images/infra-event/jobs-thumbnail.png");
      background-size: cover;
      .title-top {
        margin-top: 12px;
        display: flex;
        align-items: baseline;
        justify-content: flex-end;
      }
      .title-top-sub {
        font-size: 24px;
      }
      .title-top-main {
        font-size: 42px;
      }
      .white-card {
        padding: 12px;
        text-align: center;
        background-color: ${Color.White};
        border-radius: ${RadiusSize.Large}px;
      }
      .white-card-description {
        margin-bottom: 8px;
        font-size: ${TextSize.S}px;
        line-height: ${LineHeight.XS}%;
        color: ${Color.Black};
      }
      .white-card-title {
        font-size: ${TextSize.L}px;
        color: ${Color.Attention};
      }
    }
  }
  .description {
    padding: 24px;
    line-height: ${LineHeight.M}%;
    background-color: ${Color.White};
    border-radius: 0 0 8px 8px;
  }
`
export const EventTransitionLink = styled(TransitionLink)`
  margin-top: 16px;
  padding: 12px;
  font-size: 16px;
`
export const ScoutContainer = styled.div`
  .heading {
    margin-bottom: 36px;
    font-size: ${TextSize["XL"]}px;
    font-weight: bold;
    line-height: ${LineHeight.S}%;
    color: ${Color.Gray};
    transform: rotate(-2deg);
    ${IsMobile(`
      margin-bottom: 24px;
      font-size: ${TextSize["L"]}px;
    `)}
    .emphasis {
      font-size: ${TextSize["2XL"]}px;
      color: ${Color.Attention};
      ${IsMobile(`
      font-size: ${TextSize["XL"]}px;
    `)}
    }
  }
  .content-wrapper {
    display: flex;
    justify-content: center;
  }
  .content {
    width: 100%;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    ${IsMobile(`
      flex-direction: column;
    `)}
  }
  .thumbnail {
    max-width: 375px;
    ${IsMobile(`
      width: 94%;
      margin-bottom: 24px;
    `)}
  }
  .description {
    line-height: ${LineHeight.M}%;
  }
`
export const Feature = styled.div`
  display: flex;
  margin-top: ${SpacingSize["4XL"]}px;
  &.reverse {
    flex-direction: row-reverse;
  }
  ${IsMobile(css`
    margin-top: 40px;
  `)}
`
export const FeatureDecoration = styled.div`
  position: relative;
  padding: 0 ${SpacingSize.XL}px;
  margin: -${SpacingSize.XL}px 0;
  ${IsMobile(css`
    margin: -20px 0;
    padding: 0 16px 0 0;
    &.reverse {
      padding: 0 0 0 16px;
    }
  `)}
`
export const FeatureDecorationImg = styled.img`
  position: absolute;
  background: ${Color.BackgroundGray};
  padding-bottom: ${SpacingSize.XS}px;
`
export const FeatureDecorationLine = styled.div`
  width: 1px;
  height: 100%;
  margin: 0 10px;
  background: ${Color.Primary};
`
export const FeatureCard = styled.div`
  display: flex;
  align-items: center;
  padding: ${SpacingSize["2XL"]}px;
  background: ${Color.White};
  width: 100%;
  border-radius: ${RadiusSize.Medium}px;
  border: 1px solid ${Color.BorderGray};
  &.reverse {
    flex-direction: row-reverse;
  }
  ${IsMobile(css`
    padding: 32px 24px 24px;
    flex-direction: column;
    margin-right: -16px;
    border-radius: 8px 0 0 8px;
    &.reverse {
      flex-direction: column;
      margin-right: 0;
      margin-left: -16px;
      border-radius: 0 8px 8px 0;
    }
  `)}
`
export const FeatureCardImg = styled.img`
  margin-right: ${SpacingSize.XL}px;
  &.reverse {
    margin-right: 0;
    margin-left: ${SpacingSize.XL}px;
  }
`
export const FeatureHeading = styled(Typography)`
  ${IsMobile(css`
    text-align: center;
    margin-top: 16px;
  `)}
`
export const FeatureCardText = styled.div``
export const FeatureBody = styled(Typography)`
  color: ${Color.Gray};
  margin-top: ${SpacingSize.XS}px;
`
export const Content = styled.div`
  display: flex;
  margin: 84px -${SpacingSize.XS}px 0;
  ${IsMobile(css`
    flex-direction: column;
  `)}
`
export const ContentCard = styled.div`
  width: 33.3%;
  padding: 0 ${SpacingSize.XS}px;
  ${IsMobile(css`
    width: 100%;
    &:not(:first-child) {
      margin-top: 100px;
    }
  `)}
`
export const ContentCardInner = styled.div`
  height: 100%;
  padding: ${SpacingSize.XL}px;
  background: ${Color.White};
  border-radius: ${RadiusSize.Medium}px;
  border: 1px solid ${Color.BorderGray};
  text-align: center;
`
export const ContentCardImg = styled.img`
  width: 120px;
  height: 120px;
  margin-top: -84px;
`
export const ContentHeading = styled(Typography)`
  margin-top: ${SpacingSize.M}px;
  min-height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  ${IsMobile(css`
    min-height: auto;
  `)}
`
export const ContentBody = styled(Typography)`
  color: ${Color.Gray};
  margin-top: ${SpacingSize.S}px;
  text-align: left;
`
export const RecommendContainer = styled.div`
  .sp-container {
    ${css`
      ${IsMobile(`
        max-width: 480px;
        margin: auto;
      `)}
    `}
  }
  .recommend_list {
    display: flex;
    margin-top: ${SpacingSize.XL}px;
    ${IsMobile(css`
      flex-direction: column;
    `)};
    li {
      width: 33.33%;
      text-align: center;
      &:not(:first-child) {
        margin-left: ${SpacingSize["2XL"]}px;
      }
      ${IsMobile(css`
        width: 100%;
        &:not(:first-child) {
          margin-left: 0;
          margin-top: 48px;
        }
      `)};
    }
  }
  .recommend_list-item-img {
    height: 120px;
    border-radius: 50%;
    ${Shadow.Deep};
  }
  .recommend_list-item-heading {
    margin-top: ${SpacingSize.XL}px;
    ${IsMobile(css`
      margin-top: 16px;
    `)};
  }
  .recommend_list-item-supplement {
    margin-top: ${SpacingSize.XS}px;
    ${IsMobile(css`
      margin-top: 4px;
    `)};
  }
`
export const Consult = styled.div`
  margin-top: ${SpacingSize["4XL"]}px;
  text-align: center;
`
export const LineConsultation = styled.p`
  text-align: center;
  line-height: ${LineHeight.M}%;
  color: ${Color.Gray};
  margin-top: ${SpacingSize.S}px;
`
export const CvButton = styled(CtaLink)`
  margin: ${SpacingSize.XL}px auto 0;
  max-width: 280px;
`
